import { SetContextLink } from "@apollo/client/link/context";
import { clearAssistantAuthState, getAssistantCsrfToken } from "@/auth/assistantAuth";

/**
 * Request context link that attaches the current Assistant BFF CSRF token.
 */
export const authLink = new SetContextLink(async (prev) => {
  const { headers } = prev;

  try {
    const csrfToken = getAssistantCsrfToken();
    if (!csrfToken) {
      return { ...prev, headers };
    }

    return {
      ...prev,
      headers: { ...headers, [csrfToken.headerName]: csrfToken.token },
    };
  } catch (e) {
    console.error("Error in auth link:", e);
    return { ...prev, headers };
  }
});

/**
 * Clear all cached auth state.
 */
export function clearAllCaches(): void {
  try {
    clearAssistantAuthState();
  } catch (error) {
    console.warn("Failed to clear auth cache:", error);
  }
}
